import React, { useState, useEffect, useRef } from "react";
import "./patientProfileList.css";
import Widgets from "../../widgets";
import Icons from "../../Assets/Icons";
import authService from "../../services/authService";
import { useDispatch, useSelector } from "react-redux";
import { editPatientProfile, getPatientList, getRegisteredPatientList, getVerifiedPfp } from "../../modules/patientProfile/patientProfileThunk";
import ToastPopup from "../../widgets/Toast/toastPopup";
import { resetEditProfileRequest, resetGetProfileList, resetGetVerifiedPfp } from "../../modules/patientProfile/patientProfileSlice";
import { useTranslation } from "react-i18next";
import { setStatus } from "../../modules/status/status";
import NoData from "../../Assets/Icons/NoData.png";
import { setVerifyType } from "../../modules/status/verificationType";
import moment from "moment";

const PatientProfileList = ({ setSelectedView, getUserId, scrollToTop }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    patientList,
    patientListError,
    patientEditProfileList,
    patientEditProfileListError,
    verifyRelativeProfile,
    getVerifiedPfpSuccess,
    getVerifiedPfpErr,
    getRegisteredPatientListSuccess,
    getRegisteredPatientListErr,
  } = useSelector((state) => state.patientProfile);
  const verifyType = useSelector((state) => state.verifyType.type);
  const breadcrumbs = ["patientProfiles"];
  const paths = ["/patient-profile"];
  const [activeList, setActiveList] = useState("verification");
  const [requestList, setRequestList] = useState([]);
  const [editRequestList, setEditRequestList] = useState([]);
  const [totalPages, setTotalPages] = useState([]);
  const [totalCount, setTotalCount] = useState([]);
  const [totalCount2, setTotalCount2] = useState([]);
  const [totalVerifiedPfp, setTotalVerifiedPfp] = useState(0);
  const [verifiedUserlist, setVerifiedUserlist] = useState([]);
  const [registeredUser, setRegisteredUser] = useState([]);
  const [registeredUserCount, setRegisteredUserCount] = useState(0);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const modalRef = useRef(null);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [searchInput, setSearchInput] = useState({});
  useEffect(() => {
    if (verifyRelativeProfile?.status === 200) {
      ToastPopup.success(t("profileEditConfirmed"));
      setActiveList("edit");
      scrollToTop();
    }
    if (verifyType === "editReq") {
      setActiveList("edit");
    }
  }, [verifyRelativeProfile, verifyType]);

  useEffect(() => {
    if (getRegisteredPatientListErr) {
      ToastPopup.error(getRegisteredPatientListErr);
    }
    if (getRegisteredPatientListSuccess) {
      setRegisteredUser(getRegisteredPatientListSuccess.data.users.data);
      setRegisteredUserCount(getRegisteredPatientListSuccess.data.totalDototalDocuments);
      setTotalPages(getRegisteredPatientListSuccess.data.totalPages);
      setCurrentPage(getRegisteredPatientListSuccess.data.currentPage);
    }
  }, [getRegisteredPatientListSuccess, getRegisteredPatientListErr]);

  const fetchPatientList = (pageNumber, status = selectedStatuses, search = searchInput) => {
    const page = pageNumber ?? currentPage ?? 1;
    const limit = itemsPerPage;
    if (activeList === "edit") {
      dispatch(editPatientProfile({ page, limit, search, status }));
    } else if (activeList === "verification") {
      dispatch(getPatientList({ page, limit, search, status }));
    } else if (activeList === "registeredUser") {
      dispatch(getRegisteredPatientList({ page, limit, search, status }));
    } else {
      dispatch(getVerifiedPfp({ page, limit, search }));
    }
  };
  const handleClick = (pageNumber) => {
    scrollToTop();
    fetchPatientList(pageNumber);
  };

  const handlePrevNext = (direction) => {
    scrollToTop();
    if (direction === "prev" && currentPage > 1) {
      fetchPatientList(currentPage - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      fetchPatientList(currentPage + 1);
    }
  };

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, { type: "ellipsis" }, totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, { type: "ellipsis" }, totalPages - 1, totalPages);
      } else {
        pages.push(1, { type: "ellipsis" }, currentPage, { type: "ellipsis" }, totalPages);
      }
    }
    return pages;
  };

  useEffect(() => {
    if (patientEditProfileListError) {
      ToastPopup.error(patientEditProfileListError);
    }
    if (patientEditProfileList && patientEditProfileList.status === "success") {
      setEditRequestList(patientEditProfileList.data.userProfileVerificationRequest);
      setTotalPages(patientEditProfileList.data.totalPages);
      setCurrentPage(patientEditProfileList.data.currentPage);
      setTotalCount2(patientEditProfileList.data.totalDocuments);
    }
    dispatch(resetEditProfileRequest());
  }, [patientEditProfileList, patientEditProfileListError]);

  useEffect(() => {
    if (getVerifiedPfpErr) {
      ToastPopup.error(getVerifiedPfpErr);
    }
    if (getVerifiedPfpSuccess && getVerifiedPfpSuccess.status === "success") {
      setTotalVerifiedPfp(getVerifiedPfpSuccess.data.totalDocuments);
      setTotalPages(getVerifiedPfpSuccess.data.totalPages);
      setVerifiedUserlist(getVerifiedPfpSuccess.data.userProfileVerificationRequests);
      setCurrentPage(getVerifiedPfpSuccess.data.currentPage);
    }
  }, [getVerifiedPfpSuccess, getVerifiedPfpErr]);

  useEffect(() => {
    fetchPatientList(1);
  }, [activeList]);

  useEffect(() => {
    if (patientListError) {
      ToastPopup.error(patientListError);
    }
    if (patientList && patientList.status === "success") {
      setRequestList(patientList.data.userProfileVerificationRequests);
      if (activeList === "verification") {
        setTotalPages(patientList.data.totalPages);
      }
      setCurrentPage(patientList.data.currentPage);
      setTotalCount(patientList.data.totalDocuments);
    }
    dispatch(resetGetProfileList());
  }, [patientListError, patientList]);

  // useEffect(() => {
  //   fetchPatientList();
  // }, []);
  useEffect(() => {
    if (typeof searchInput === "string") {
      fetchPatientList();
    }
  }, [searchInput]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowFilter(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  useEffect(() => {
    const activeList = authService.getActiveList();
    if (activeList) {
      setActiveList(activeList);
    }
  }, []);

  const handleActiveChange = (section) => {
    setActiveList(section);
    authService.setActiveList(section);
    // setSelectedView("verification");
  };

  const handleSearch = (query) => {
    setSearchInput(query);
  };

  const statusTypes = ["OPEN", "IN_REVIEW"];

  const handleStatusChange = (statuses) => {
    fetchPatientList(1);
    setShowFilter(false);
  };

  const handleVerifyClick = (item) => {
    if (activeList === "registeredUser") {
      return;
    }
    if (activeList === "verifiedPfp") {
      setSelectedView("patientProfileView");
    } else {
      setSelectedView("verification");
    }
    dispatch(setStatus(item.status));
    if (item.user) {
      if (item.user.hnNumber) {
        dispatch(setVerifyType("withHN"));
      } else {
        dispatch(setVerifyType("withoutHN"));
      }
    } else {
      if (item.relative) {
        dispatch(setVerifyType("editReq"));
      }
    }
    getUserId(item._id);
  };
  return (
    <div className="ppl-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading">{t("users")}</div>
      <div className="department-search-line">
        <Widgets.SearchBox onSearch={handleSearch} placeholder={activeList === "registeredUser" ? "searchregisteredUser" : "searchByHNorPatient"} />
        {/* <Widgets.SearchBox onSearch={handleSearch} placeholder={"avi implement nhi hua h"} /> */}
      </div>
      <div className="ppl-display">
        <section>
          <span className={`tab ${activeList === "edit" ? "active" : ""}`} onClick={() => handleActiveChange("edit")}>
            {t("profileEditReq")} {activeList === "edit" && `(${totalCount2})`}
          </span>
          <span className={`tab ${activeList === "verification" ? "active" : ""}`} onClick={() => handleActiveChange("verification")}>
            {t("profileVerify")} {activeList === "verification" && `(${totalCount})`}
          </span>
          <span className={`tab ${activeList === "verifiedPfp" ? "active" : ""}`} onClick={() => handleActiveChange("verifiedPfp")}>
            {t("verifiedPpf")} {activeList === "verifiedPfp" && `(${totalVerifiedPfp})`}
          </span>
          <span className={`tab ${activeList === "registeredUser" ? "active" : ""}`} onClick={() => handleActiveChange("registeredUser")}>
            {t("registeredUser")} {activeList === "registeredUser" && `(${registeredUserCount})`}
          </span>
        </section>
        {!["verifiedPfp", "registeredUser"].includes(activeList) && (
          <div className="ppl-icon-container" ref={modalRef}>
            <section className="ppl-icon-filter" onClick={() => setShowFilter(!showFilter)}>
              <img src={Icons.filterIcon} alt="icon-filter" />
            </section>
            {showFilter && (
              <section className="ppl-status-dropdown">
                <Widgets.StatusDropdown
                  statusTypes={statusTypes}
                  onStatusChange={handleStatusChange}
                  setShowFilter={setShowFilter}
                  selectedStatuses={selectedStatuses}
                  setSelectedStatuses={setSelectedStatuses}
                />
              </section>
            )}
          </div>
        )}
      </div>
      <div className="ppl-list-container">
        <div className="ppl-table-body">
          <table className="ppl-table">
            <thead className="ppl-thead">
              <tr>
                <th>{t("patientDetails")}</th>
                {activeList !== "registeredUser" && <th>{t("hnNumber")}</th>}
                <th>{t("emailId")}</th>
                <th>{t("phoneNumber")}</th>
                {activeList !== "registeredUser" && <th>{t("status")}</th>}
                {activeList === "registeredUser" && <th>{t("createdAt")}</th>}
              </tr>
            </thead>
            <tbody className="ppl-tbody">
              {(activeList === "edit" ? editRequestList : activeList === "verifiedPfp" ? verifiedUserlist : activeList === "registeredUser" ? registeredUser : requestList).map((item, index) => {
                const person = activeList === "edit" ? item.relative : activeList === "verifiedPfp" ? item : activeList === "registeredUser" ? item : item.user;
                return (
                  <tr
                    key={index}
                    className={`ppl-table-row ${activeList === "registeredUser" ? "cursor-not-allowed" : "cursor-pointer"}`}
                    onClick={() => {
                      handleVerifyClick(item);
                    }}
                  >
                    <td>
                      <div className="ppl-td-first">
                        <div>
                          {person?.profilePhoto ? (
                            <img src={person.profilePhoto} alt="profile-pic" className="ppl-td-profile" />
                          ) : (
                            <div className="ppl-detials">
                              <img src={Icons.profile} alt="profile-pic" className="ppl-td-profile-none" />
                            </div>
                          )}
                        </div>
                        <div className="ppl-name-email">
                          <section>{person.firstName + " " + person.lastName}</section>
                          {/* <section className="ppl-email">{person.email}</section> */}
                        </div>
                      </div>
                    </td>
                    {activeList !== "registeredUser" && <td>{person.hnNumber}</td>}
                    <td>{person.email}</td>
                    <td>
                      +{person.countryCode} {person.phoneNumber}
                    </td>
                    {activeList !== "registeredUser" && (
                      <td className={`ppl-status ${item.status ? item.status : item.isHNVerified ? "verified" : "unverified"}`}>
                        {item.status === "OPEN" && (
                          <p>
                            <img src={Icons.openBox} alt="box" />
                            {t("open")}
                          </p>
                        )}
                        {item.status === "IN_REVIEW" && (
                          <p>
                            <img src={Icons.inReview} alt="box" />
                            {t("inReview")}
                          </p>
                        )}
                        {item.isHNVerified && (
                          <>
                            <p>
                              <img src={Icons.tick} alt="box" />
                              {t("Verified")}
                            </p>
                            <div className="pil-ca">{moment(item?.userVerifiedOn).format("DD/MM/YYYY HH:mm")}</div>
                          </>
                        )}
                      </td>
                    )}
                    {activeList === "registeredUser" && <td>{moment(person.createdAt).format("DD/MM/YYYY HH:mm")}</td>}
                  </tr>
                );
              })}
            </tbody>
          </table>
          {totalPages === 0 && (
            <div className="no-record-container ppl">
              <div className="no-record-icon">
                <img src={NoData} alt="No Data Found" />
              </div>
              <div className="no-record-text">{t("noRecordFound")}</div>
            </div>
          )}
        </div>
        <div className="department-pagination-list">
          {totalPages > 0 && (
            <>
              <button onClick={() => handlePrevNext("prev")} disabled={currentPage === 1} className="department-pagination-prev-list">
                <img src={Icons.leftArrow} alt="<" />
              </button>
              {renderPagination().map((page, index) => (
                <button
                  key={index}
                  onClick={() => typeof page === "number" && handleClick(page)}
                  disabled={page === currentPage || page.type === "ellipsis"}
                  className={`department-pagination-btn-list ${page === currentPage ? "active-list" : ""} ${page.type === "ellipsis" ? "ellipse" : ""}`}
                >
                  {typeof page === "number" ? page : <img src={Icons.extraIcon} alt="..." className="department-extra-icon" />}
                </button>
              ))}
              <button onClick={() => handlePrevNext("next")} disabled={currentPage === totalPages} className="department-pagination-next-list">
                <img src={Icons.rightArrow} alt=">" />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default PatientProfileList;
